{
  "VALIDATION_FAILED": "The submitted data is not valid",
  "USERNAME_TAKEN": "This username is already in use",
  "SYSTEM_EXISTS": "A system with this code already exists",
  "NO_PLATFORM_ACCESS": "You do not have access to this platform",
  "UA_UNAVAILABLE": "Unified Access could not be reached. Try again shortly.",
  "INTEGRATION_UNAUTHORIZED": "Invalid integration credentials",
  "UNAUTHENTICATED": "You need to sign in",
  "INVALID_CREDENTIALS": "Invalid email or password",
  "FORBIDDEN": "You do not have permission for this action",
  "NOT_FOUND": "The requested item was not found",
  "CONFLICT": "Conflicting data. Reload the current data.",
  "UNIQUE_VIOLATION": "This value is already in use",
  "FOREIGN_KEY_VIOLATION": "This item is referenced elsewhere and cannot be deleted",
  "RATE_LIMITED": "Too many attempts. Try again shortly.",
  "IDEMPOTENCY_KEY_REUSED": "This request number was already used for another operation",
  "REQUEST_IN_PROGRESS": "This request is still being processed",
  "PAYLOAD_TOO_LARGE": "The submitted data exceeds the maximum size",
  "UNPROCESSABLE": "The request could not be processed. Check the submitted data.",
  "INTERNAL_ERROR": "The operation could not be completed. Try again or contact your administrator.",
  "SERVICE_UNAVAILABLE": "The service is unavailable right now. Try again shortly.",
  "network": "Could not reach the server. Check your connection and try again.",
  "timeout": "We could not confirm this finished. Check the current state before trying again.",
  "IDEMPOTENCY_CONFLICT": "The same request key was already used for a different request",
  "TABLET_NOT_AVAILABLE": "This tablet is not available in this branch",
  "TABLET_BUSY": "The tablet is busy",
  "TABLET_PAIRING_CODE_INVALID": "The pairing code is wrong or has expired",
  "TABLET_UNAUTHENTICATED": "This device is not paired",
  "TABLET_INACTIVE": "This tablet is disabled",
  "TASK_CLOSED": "This operation has ended",
  "TASK_NOT_SUBMITTED": "The customer has not signed yet",
  "SIGNATURE_REQUIRED": "Signature is required",
  "LINK_INVALID": "This request has ended and is no longer available",
  "LINK_UNAVAILABLE": "Filling in on the employee's device is not available right now"
}
